// Track the last few vet practices a user has viewed, stored in localStorage
// so it works for both signed-out and signed-in users without a round-trip.

const KEY = "gpv:recently-viewed-vets";
const MAX = 8;

export interface RecentVet {
  id: string;
  slug?: string | null;
  name: string;
  postcode?: string | null;
  viewedAt: number;
}

function read(): RecentVet[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? (arr as RecentVet[]) : [];
  } catch {
    return [];
  }
}

function write(rows: RecentVet[]) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify(rows.slice(0, MAX)));
  } catch {
    // quota or privacy mode - silently ignore
  }
}

export function recordRecentVet(vet: Omit<RecentVet, "viewedAt">) {
  if (!vet?.id || !vet?.name) return;
  const now = Date.now();
  const existing = read().filter((v) => v.id !== vet.id);
  write([{ ...vet, viewedAt: now }, ...existing]);
}

export function getRecentVets(): RecentVet[] {
  return read();
}

export function clearRecentVets() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // no-op
  }
}
